import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import CircularProgress, {
  CircularProgressProps
} from '@mui/material/CircularProgress'

import { ButtonProps } from './Button.component'

export const setStyleButton = ({ variant }: ButtonProps) => {
  switch (variant) {
    case 'text':
      return {
        color: '#030096',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: 'transparent'
        },
        '&:disabled': {
          color: '#030096',
          backgroundColor: 'transparent',
          opacity: 0.4
        }
      }
    case 'outlined':
      return {
        color: '#030096',
        backgroundColor: '#fff',
        borderColor: '#030096',
        '&:hover': {
          backgroundColor: '#fff',
          borderColor: '#030096'
        },
        '&:disabled': {
          color: '#030096',
          borderColor: '#030096',
          backgroundColor: '#fff',
          opacity: 0.4
        }
      }

    default:
    case 'contained':
      return {
        color: '#fff',
        backgroundColor: '#030096',
        borderColor: '#030096',
        '&:hover': {
          backgroundColor: '#030096',
          borderColor: '#030096'
        },
        '&:disabled': {
          color: '#fff',
          backgroundColor: '#030096',
          opacity: 0.4
        }
      }
  }
}

export const ButtonStyled = styled(Button)<ButtonProps>(
  ({ variant, textTransform }) => ({
    ...setStyleButton({ variant }),
    width: '280px',
    height: '48px',
    textTransform: textTransform,
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 600,
    borderRadius: '6px'
  })
)

export const ButtonLoadingStyled = styled(LoadingButton)<ButtonProps>(
  ({ variant }) => ({
    ...setStyleButton({ variant }),
    opacity: 0.4,
    width: '280px',
    height: '48px',
    textTransform: 'capitalize',
    fontSize: '18px',
    lineHeight: '22px',
    borderRadius: '6px'
  })
)

interface ProgressProps extends CircularProgressProps {
  colorSpinner?: string
}

export const CircularProgressStyled = styled(CircularProgress)<ProgressProps>(
  ({ colorSpinner = 'white' }) => ({
    color: colorSpinner
  })
)
